// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a974aec5","885":"fc9c31ce","977":"86d65106"}[chunkId] + ".chunk.js";
};